import React from "react";
import EmploymentInformationForm from "./EmploymentInformationForm";

const EmploymentInformation = ({
  handleChange,
  employmentInformation,
  isIdAvailable = false,
}) => {
  return (
    <div className="formgrid grid">
      <div className="field">
        <p className="heading">Employment Information</p>
        <p className="description">
          Defines the employee’s role, type, and status within the organization
        </p>
      </div>
      <EmploymentInformationForm
        employmentInformation={employmentInformation}
        handleChange={handleChange}
        isLoading={false}
        isEdit={true}
        isIdAvailable={isIdAvailable}
      />
    </div>
  );
};

export default EmploymentInformation;
